import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'demooz-card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss'],
    imports: []
})
export class DemoozCardComponent  implements OnInit {

    @Input({alias : 'withMargin', required : false}) withMargin: boolean = true;
    @Input({alias : 'fullHeight', required : false}) fullHeight: boolean = false;

    constructor() { }

    ngOnInit() {}

}
